import React from 'react';
import { Link } from 'react-router-dom';
import MarketingShell from '../marketing/MarketingShell';
import PageMeta from '../seo/PageMeta';
import { QNAREAD } from '../../config/appLabels';

const LandingPage = () => (
  <MarketingShell variant="brand">
    <PageMeta canonicalPath="/brand" />
    <section className="landing-hero">
      <span className="landing-hero-badge">Marketing · Brand story</span>
      <h1>{QNAREAD.tagline}</h1>
      <p className="landing-hero-tagline">
        Notebooks, PDF import, and spaced review—built so what you learn today is still there when it matters.
      </p>
      <div className="marketing-hero-actions" style={{ justifyContent: 'center' }}>
        <Link to="/features" className="marketing-btn marketing-btn-primary">Explore the product</Link>
        <Link to="/login" className="marketing-btn marketing-btn-secondary">Sign in to app</Link>
      </div>
      <div className="landing-proof">
        <div><strong>Search</strong>Server-side library</div>
        <div><strong>Practice</strong>Spaced repetition</div>
        <div><strong>AI</strong>Explain on demand</div>
        <div><strong>Secure</strong>MFA optional</div>
      </div>
    </section>

    <section className="landing-story">
      <h2>Marketing vs. product vs. sign-in</h2>
      <p>
        This page is our <strong>brand home</strong> — why we exist and who we serve.
        The <Link to="/features">product tour</Link> and <Link to="/pricing">pricing</Link> pages focus on capabilities and plans.
        <Link to="/login"> Sign in</Link> takes you to a dedicated account experience (onboarding → learning hub) — not this marketing layout.
      </p>
    </section>

    <section className="marketing-audience" style={{ marginTop: 48 }}>
      <h2>Who it&apos;s for</h2>
      <div className="marketing-audience-links">
        <Link to="/for-students">Students</Link>
        <Link to="/for-developers">Developers</Link>
        <Link to="/for-interview-prep">Interview prep</Link>
        <Link to="/for-teams">Teams</Link>
      </div>
    </section>
  </MarketingShell>
);

export default LandingPage;
